class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.hasRemovedInitialClass = false;
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search');
    this.predictiveSearchSection = this.predictiveSearchResults.dataset.searchId ?? 'predictive-search';

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.form.addEventListener('reset', () => {
      setTimeout(() => {
        this.input.value = '';
        this.close();
      }, 100);
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);

    if (!this.hasRemovedInitialClass) {
      this.predictiveSearchResults.classList.remove('is-initial');
      this.hasRemovedInitialClass = true;
    }
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=${this.predictiveSearchSection}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.predictive-result').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.classList.remove('hidden');
    this.predictiveSearchResults.classList.add('shown');
  }

  close() {
    this.predictiveSearchResults.classList.add('hidden');
    this.predictiveSearchResults.classList.remove('shown');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
